// src/Public/navbar-data.js

const NavbarData = {
    en: {
        // Nav Links
        home: 'Home',
        services: 'Services',
        about: 'About Us',
        ourWork: 'Photo Gallery',
        blogs: 'Blog',
        contact: 'Contact',
        admin: 'Admin',
        logout: 'Log Out',

        // Services dropdown items
        servicesMenu: [
            { label: 'Dock Construction',           slug: 'dock-construction' },
            { label: 'Boat Lift Sales & Installation', slug: 'boat-lift-installation' },
            { label: 'Boat Lift Maintenance',       slug: 'boat-lift-maintenance' },
            { label: 'Boat Lift Repair',            slug: 'boat-lift-repair' },
            { label: 'Dock Repair',                 slug: 'dock-repair' },
            { label: 'Tiki Huts & Outdoor Structures', slug: 'tiki-huts' },
        ],

        // Top Bar Texts
        topBarSubtitle: '',
        shippingPromo: 'FREE ESTIMATES',

        // Modal Specific
        modal: {
            back: 'Back',
            viewAll: 'View All in',
            searchPlaceholder: 'Search services...',
        },

        // Banner Messages
        bannerMessages: [
            { text: "30+ Years of Experience | License #CBC1260600", value: "/about" },
            { text: "Dock Construction • Boat Lifts • Repair & Maintenance", value: "/services" },
            { text: "Call Us for a Free Estimate — (239) 542-1004", value: "/contact" }
        ]
    },

    he: {
        // Nav Links (English only — US company)
        home: 'Home',
        services: 'Services',
        about: 'About Us',
        ourWork: 'Photo Gallery',
        blogs: 'Blog',
        contact: 'Contact',
        admin: 'Admin',
        logout: 'Log Out',

        // Services dropdown items
        servicesMenu: [
            { label: 'Dock Construction',           slug: 'dock-construction' },
            { label: 'Boat Lift Sales & Installation', slug: 'boat-lift-installation' },
            { label: 'Boat Lift Maintenance',       slug: 'boat-lift-maintenance' },
            { label: 'Boat Lift Repair',            slug: 'boat-lift-repair' },
            { label: 'Dock Repair',                 slug: 'dock-repair' },
            { label: 'Tiki Huts & Outdoor Structures', slug: 'tiki-huts' },
        ],

        // Top Bar Texts
        topBarSubtitle: '30+ Years of Experience | License #CBC1260600 | Cape Coral, FL',
        shippingPromo: 'FREE ESTIMATES',

        // Modal Specific
        modal: {
            back: 'Back',
            viewAll: 'View All in',
            searchPlaceholder: 'Search services...',
        },

        // Banner Messages
        bannerMessages: [
            { text: "30+ Years of Experience | License #CBC1260600", value: "/about" },
            { text: "Dock Construction • Boat Lifts • Repair & Maintenance", value: "/services" },
            { text: "Call Us for a Free Estimate — (239) 542-1004", value: "/contact" }
        ]
    }
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getNavbarData(language) {
    const lang = resolveLanguage(language);
    return NavbarData[lang] || NavbarData.en;
}

export default NavbarData;
